import { render } from "./LogListWidget.vue?vue&type=template&id=63f62d39"
import script from "./LogListWidget.vue?vue&type=script&lang=js"
export * from "./LogListWidget.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__